export default (eventName) => ({
	event: eventName
});
